export { default as HeaderSinglePortalMode } from './header-single-portal-mode';
